export const flexAlign = (alignment: 'left' | 'right' | 'center') =>
  alignment === 'left'
    ? 'flex-start'
    : alignment === 'right'
    ? 'flex-end'
    : 'center'
